// Canonical skill catalog for Nexus Forge.
//
// Any module that validates or references skill IDs imports from here.
// Test-side hardcoded skill-ID lists are forbidden — derive from SKILL_IDS.
// Unknown skill IDs are rejected at RPC boundaries (see player-skills.ts).
//
// Phase 6 Block B: expanded from 3 → 11 skills. Adjacency graph lives in
// shared/skills-graph.ts; tier thresholds live in balance.skills.tierThresholds.

export const SKILL_IDS = [
  "mining",
  "crafting",
  "electronics",
  "wiring",
  "chemistry",
  "circuit-design",
  "power-systems",
  "radiation-handling",
  "explosives",
  "automation",
  "reactor-tech",
  // Phase 6 Block C: utility skill — not in adjacency graph, no crafting adjacency.
  // Unlocks cross-station price queries at Journeyman+ (500 XP).
  "market-analysis",
] as const;

export type SkillId = (typeof SKILL_IDS)[number];

export function isValidSkillId(id: string): id is SkillId {
  return (SKILL_IDS as readonly string[]).includes(id);
}
